export const accountingMain = {
    title: "Statistiques finances",
    loading: "Chargement en cours…",
    'payment-modes': "Modes de paiement",
    'evolution-title': "Évolution des recettes / dépenses (en {year})"
}
